<script>
import EntriesList from '../../entries/components/EntriesList';

export default {
  extends: EntriesList
};
</script>
